import { CloseOutlined } from "@ant-design/icons";
import { Modal } from "antd";
import { useEffect, useState } from "react";
import { Button, Carousel } from "../../components";
import { useApp, useMenu, useSearchParams } from "../../hooks";
import { useCartStore, useMenuStore } from "../../stores";
import { Tools } from "../../utils";
import Details from "../menuItemCard/details";

const Overlay = () => {
  const { searchParams, removeParams } = useSearchParams({ product: "" });
  const categories = useMenuStore((state) => state.categories);
  const { items, openItem } = useMenu();
  const { modal, message } = useApp();
  const addToCart = useCartStore((state) => state.add);
  const close = () => removeParams("product");
  const [promosOpen, setPromosOpen] = useState(false);
  const promotions = items.filter(
    (item) =>
      item.isPromotional &&
      item.isAvailable &&
      (item.promotionalImageUrl || item.imageUrl),
  );

  useEffect(() => {
    if (categories && !searchParams.product && promotions.length)
      setPromosOpen(true);
  }, [categories]);

  useEffect(() => {
    if (!searchParams.product || !categories) return;
    const item = items.find((item) => item.uuid === searchParams.product);
    if (!item || !item.isAvailable) {
      message.error("Item is no longer available");
      close();
      return;
    }
    const details = modal.show({
      manageHistory: false,
      title: item.name,
      classNames: { body: "p-0 item-details-body" },
      onClose: close,
      content: (
        <Details
          {...(item as any)}
          onAdd={async (next, extra) => {
            await addToCart(next, extra);
            details.destroy();
            close();
          }}
        />
      ),
    });

    return () => details.destroy();
  }, [searchParams.product, categories, items]);

  const slides = promotions.map((item) => (
    <div key={item.uuid}>
      <button
        type="button"
        className="m-0 block w-fit max-w-full cursor-pointer border-0 bg-transparent p-0"
        onClick={() => {
          setPromosOpen(false);
          openItem(item.uuid);
        }}
      >
        <img
          alt={item.name}
          className="block h-auto w-auto max-h-[78vh] max-w-[min(calc(100vw_-_16px),_64rem)] rounded-[1.6rem] object-contain"
          src={Tools.mediaUrl(item.promotionalImageUrl || item.imageUrl)}
        />
      </button>
    </div>
  ));

  return (
    <Modal
      centered
      footer={null}
      closable={false}
      width="auto"
      open={promosOpen}
      onCancel={() => setPromosOpen(false)}
      className="!pointer-events-auto !top-0 !mx-auto !w-fit !max-w-[min(calc(100vw_-_16px),_64rem)] !flex-none [&>div]:w-fit [&>div]:max-w-full"
      classNames={{ wrapper: "items-center justify-center" }}
      modalRender={() => (
        <div className="relative w-fit max-w-[min(calc(100vw_-_16px),_64rem)] [&:has(.ant-carousel)]:w-[min(calc(100vw_-_16px),_64rem,_70vh)] [&:has(.ant-carousel)_.slick-slider]:w-[min(calc(100vw_-_16px),_64rem,_70vh)] [&:has(.ant-carousel)_.slick-list]:aspect-square [&:has(.ant-carousel)_.slick-list]:w-[min(calc(100vw_-_16px),_64rem,_70vh)] [&:has(.ant-carousel)_.slick-list]:overflow-hidden [&:has(.ant-carousel)_.slick-list]:rounded-[1.6rem] [&:has(.ant-carousel)_.slick-track]:h-full [&:has(.ant-carousel)_.slick-slide]:h-full [&:has(.ant-carousel)_.slick-slide>div]:h-full [&:has(.ant-carousel)_.slick-slide>div>div]:h-full [&:has(.ant-carousel)_.slick-slide_button]:h-full [&:has(.ant-carousel)_.slick-slide_button]:w-full [&:has(.ant-carousel)_img]:!h-full [&:has(.ant-carousel)_img]:!w-full [&:has(.ant-carousel)_img]:!max-h-full [&:has(.ant-carousel)_img]:!max-w-full [&:has(.ant-carousel)_img]:!object-cover [&_.slick-arrow]:!hidden [&_.slick-dots]:static [&_.slick-dots]:mt-[1.2rem] [&_.slick-dots_li_button]:!bg-white">
          {slides.length > 1 ? (
            <Carousel
              dots
              autoplay
              infinite
              children={slides}
              autoplaySpeed={4000}
            />
          ) : (
            slides
          )}
          <Button
            shape="circle"
            aria-label="Close"
            icon={<CloseOutlined />}
            className="!absolute !right-[2rem] !top-[2rem] !z-[2] !h-[3.6rem] !w-[3.6rem] !min-w-[3.6rem] !border-0 !bg-white !p-0 !text-[#111] !shadow-[0_2px_8px_rgba(0,0,0,0.25)] [&_.anticon]:text-[1.6rem]"
            style={{ color: "#111" }}
            onClick={() => setPromosOpen(false)}
          />
        </div>
      )}
    />
  );
};

export default Overlay;
